<template>
  <div>
    <v-row
      v-for="country in countries"
      :key="country.id"

      align="center"
      class="list--bordered py-1"
    >
      <v-col
        class="shrink"
      >
        <v-icon
          color="red"
          @click="removeSelectedCountry(country.id)"
        >
          close
        </v-icon>
      </v-col>
      <v-col
        class="subtitle-1 grow"
      >
        {{ country.name }}
      </v-col>
      <v-col
        v-if="$can('set-income-costs', 'YachtModel')"
        cols="4"
        class="mr-1"
      >
        <currency-input
          v-model="country.pivot.yearly_income"
          :suffix="currency"
          :precision="0"
          label="Yearly Income"
          hide-details
          solo
          flat
          class="pa-0"
        />
      </v-col>
      <v-col
        v-if="$can('set-income-costs', 'YachtModel')"
        cols="4"
      >
        <currency-input
          v-model="country.pivot.yearly_expense"
          :suffix="currency"
          :precision="0"
          label="Yearly Expense"
          hide-details
          solo
          flat
          class="pa-0"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import CurrencyInput from '@/components/helpers/CurrencyInput'

  export default {
    name: 'YachtModelCountryList',
    components: {
      CurrencyInput
    },
    props: {
      countries: {
        type: Array,
        default: () => []
      },
      currency: {
        type: String,
        default: 'EUR'
      }
    },
    methods: {
      removeSelectedCountry(countryId) {
        this.$emit('remove:country', countryId)
      }
    }
  }
</script>

<style scoped>

</style>
